import { useAuth } from "react-oidc-context";
import style from "./EngagementError.module.css";

const EngagementError = () => {
  const auth = useAuth();
  const handleLogOut = () => {
    window.sessionStorage.removeItem("brf");
    auth.removeUser();
    auth.signoutRedirect();
  };
  return (
    <div className="flex flex--justify-center flex--align-center h100">
      <div className={style.container}>
        <h1>Hoppsan!</h1>
        <p className="body1 light">
          Det verkar som att du inte är styrelsemedlem i en bostadsrättsförening
          när vi frågar Bolagsverket. Du kan därför inte nyttja tjänsten.
        </p>
        <p className="body1 light mb-2">
          Gå till{" "}
          <a
            href="https://riksbyggen.se"
            target="_blank"
            title="Till Riksbyggen"
            className="body1 light underlined"
          >
            riksbyggen.se
          </a>
          .
        </p>
        <button
          className={`button button--outlined button--rounded flex flex--align-center`}
          onClick={() => handleLogOut()}
        >
          Logga ut
        </button>
      </div>
    </div>
  );
};

export default EngagementError;
